import React from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import { Grid, Typography,Box } from "@mui/material";
import { useSpring, animated } from "react-spring";

//media 
import profile from "../assets/formal.jpg";

//component
// import Timeline from "../components/timeline";

//social media
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import TwitterIcon from '@mui/icons-material/Twitter';


const BrandFont = {
  fontFamily: "Solitreo, cursive",
};

function AboutPage() {

  const props = useSpring({
    from: { opacity: 0, transform: "translateY(100px)" },
    to: { opacity: 1, transform: "translateY(0px)" },
    delay: 500,
  });

  return (
    <div>
      <animated.div style={props}>
      <Header />
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography          
          variant="h3"
          sx={{ ...BrandFont, textAlign: "center" }}
          mt={1}>
            About Me
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={1} sm={3}></Grid>
          <Grid Grid item xs={10} sm={6}>
            <Box mt={1} mb={1} sx={{ textAlign: "center" }} >
              <img src={profile} alt="profile" width="100%" style={{ maxWidth: "300px" }} />
            </Box>
            <Typography variant="body1" sx={{ ...BrandFont, textAlign: "justify"  }} mt={2}>
              Aniq Aqil is a passionate software engineer with a track record of accomplishments in the field of technology. Currently pursuing studies at Universiti Teknologi Malaysia, he has a strong proficiency in software development tools and technologies. Aniq is also a dedicated runner and believes 
              in striving for excellence in all aspects of life. With a commitment to personal and professional growth, Aniq is eager to take on new challenges and contribute to organizational success. 
            </Typography>
          </Grid>
          <Grid item xs={1} sm={3}></Grid>
        </Grid>
        <Typography          
          variant="h3"
          sx={{ ...BrandFont, textAlign: "center" }}
          mt={3}>
           Social Media
      </Typography> 
      <Grid container spacing={2}>
        <Grid item xs={1} sm={3}></Grid>

          <Grid Grid item xs={10} sm={6}>
            <Box mt={1} mb={1} sx={{ textAlign: "center" }} >
              <a href="https://www.facebook.com/aniq.aqil.180/" target="_blank" rel="noreferrer">
                <FacebookIcon sx={{ fontSize: 50, color: "#000", "&:hover": { color: "text.secondary" }, }} />
              </a>
              <a href="https://www.instagram.com/aniqqaqill/" target="_blank" rel="noreferrer">
                <InstagramIcon sx={{ fontSize: 50, color: "#000", "&:hover": { color: "text.secondary" }, }} />
              </a>
              
              <a href="https://twitter.com/_anqq" target="_blank" rel="noreferrer">
                <TwitterIcon sx={{ fontSize: 50, color: "#000", "&:hover": { color: "text.secondary" }, }}/>
              </a>
              <a href="https://www.youtube.com/@aniqaqil1214/videos" target="_blank" rel="noreferrer">
                <YouTubeIcon sx={{ fontSize: 50, color: "#000", "&:hover": { color: "text.secondary" }, }} />
              </a>
            </Box>
          </Grid>
          <Grid item xs={1} sm={3}></Grid>
        </Grid>
        <Typography          
          variant="h3"
          sx={{ ...BrandFont, textAlign: "center" }}
          mt={8}>
           Currently Building....
      </Typography> 

      



















      {/* timeline section
      <Typography          
          variant="h3"
          sx={{ ...BrandFont, textAlign: "center" }}
          mt={3}>
            My TimeLine
      </Typography> */}
      <Grid container spacing={2}>
        <Grid item xs={1} sm={3}></Grid>
          <Grid Grid item xs={10} sm={6}>
            <Box mt={1} mb={1} sx={{ textAlign: "center" }} >
              {/* <Timeline /> */}
            </Box>
          </Grid>
          <Grid item xs={1} sm={3}></Grid>
        </Grid>
        <Footer />
      </animated.div>
    </div>
  );
}

export default AboutPage;
